<template>
		<div class="login-container">

			<div id="background-image"></div>
			<div id="background-overlay"></div>

			<header id="header">
				<canvas id="spiders"></canvas>
			</header>
			<!-- Page container -->
			<div class="page-container">
			    <!-- Page content -->
			    <div class="page-content">
						<!-- Main content -->
						<div class="content-wrapper">

							<!-- Content area -->
							<div class="content">
								
								<!-- Advanced login -->
								<form class="m-login-form">
									<div class="panel panel-body login-form">
										<div class="text-center">
											<div class="icon-object border-warning-400 text-warning-400"><i class="icon-people"></i></div>
											<h5 class="content-group-lg">Login to your account <small class="display-block">Enter your credentials</small></h5>
										</div>

										<div class="form-group has-feedback has-feedback-left">
											<input type="text" class="form-control" placeholder="Username" v-model="account.username">
											<div class="form-control-feedback">
												<i class="icon-user text-muted"></i>
											</div>
										</div>

										<div class="form-group has-feedback has-feedback-left">
											<input type="password" class="form-control" placeholder="Password" v-model="account.password">
											<div class="form-control-feedback">
												<i class="icon-lock2 text-muted"></i>
											</div>
										</div>

										<div class="form-group">
											<button type="submit" id="onLogin" class="btn btn-primary btn-block" @click.prevent="onLogin">Login <span id="fa-loading"><i class="icon-circle-right2 position-right"></i></span></button>
										</div>

									</div>
								</form>
								<!-- /advanced login -->

							</div>
							<!-- /content area -->

						</div>
						<!-- /main content -->	
				</div>
			</div>
		</div>
</template>

<script>
import router from '@/router'
import axios from 'axios'
import { app } from '../main'
const token = localStorage.getItem('token')
export default {
  name: 'Login',
  data () {
    return {
    	account: {},
    	email: ''
    }
  },
  mounted(){
  	if (token) {
  		router.push('/goadmin/dashboard')
  	}
  },
  methods:{
  	onLogin(){
      	  let vm = this;
      	  $('#fa-loading').html('<i class="icon-spinner6 spinner position-right"></i>');
      	  $('#doLogin').prop('disabled', true);
          axios.post('login', this.account, { headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json'} })
            .then(function (response) {
                $('#fa-loading').html('<i class="icon-circle-right2 position-right"></i>');
                $('#doLogin').prop('disabled', false);
                const token = response.data.token
                localStorage.setItem('token', token)
                location.reload()
  
            })
            .catch(function (error) {
                $('span#fa-loading').html('<i class="icon-circle-right2 position-right"></i>');
                $('#doLogin').prop('disabled', false);
                Swal.fire("Notification", "Error retrieving data, please try reloading the page!", "error")
                //console.log(error);
            });
  	}
  }
}
</script>

<style lang="css" scoped>
body{
	overflow: hidden !important;
}
.panel .panel-body .login-form{
	z-index: 10 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue